const registerStyle = () => ({});

export default registerStyle;
